export function sanitizeText(text: string) {
  if (!text) return text;

  const withoutFunctionCallMarker = text.replace(/<has_function_call>/g, '');

  const withoutReasoning = withoutFunctionCallMarker.replace(
    /<reasoning>[\s\S]*?<\/reasoning>/g,
    ''
  );

  return withoutReasoning;
}
